import { useElements, useStripe } from '@stripe/react-stripe-js';
import { cloneElement } from 'react';

const StripeWrapper = (props) => {
  const elements = useElements();
  const stripe = useStripe();
  return cloneElement(props.children, {
    elements: elements,
    stripe: stripe,
    ...props
  });
};

export default StripeWrapper;
